import React from "react";
import "./HeroAddress.css";

const HeroAddress = ({
  title,
  imageUrl,
  imageUrlLeft,
  imageUrlRight,
  className = "",
}) => {
  const isCollage = imageUrlLeft && imageUrlRight;

  let bgClass = isCollage ? "collage-bg" : imageUrl ? "single-bg" : "";

  const shouldUseInlineImage = !className.includes("faq-banner");

  const backgroundStyle = isCollage
    ? {
        backgroundImage: `url(${imageUrlLeft}), url(${imageUrlRight})`,
        backgroundSize: "50% 100%, 50% 100%",
        backgroundPosition: "left center, right center",
        backgroundRepeat: "no-repeat",
      }
    : shouldUseInlineImage && imageUrl
    ? {
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }
    : {};

  return (
    <div
      className={`hero-address ${bgClass} ${className}`}
      style={backgroundStyle}
    >
      <div className="hero-address__inner">
        <h1 className="hero-address__title">{title}</h1>
      </div>
    </div>
  );
};

export default HeroAddress;
